import React, { Component } from "react";
import TermsAndConditionView from "./TermsAndConditionView";
class TermsAndConditionContainer extends Component {
  render() {
    return <TermsAndConditionView {...this.props} />;
  }
}


export default TermsAndConditionContainer;